import React, { useState } from 'react';
import classNames from 'classnames';

import { Icon } from '../Icon/Icon';

interface Props {
  id: string;
  label?: string;
  placeholder?: string;
  onChange: (value: string) => void;
  className?: string;
  options: string[];
  error?: string | boolean;
  defaultValue?: string;
  disabledOptions?: string[];
  labelClassName?: string;
  children?: React.ReactNode;
  showErrorOutLine?: boolean; // Case where we need the ability to show error outline if the input is 1 of 2 inputs
  isRequired?: boolean;
}

// @NOTE Can use SelectInput in block form and pass through your own label
export const SelectInput = (props: Props) => {
  const {
    id,
    label,
    placeholder,
    onChange,
    className,
    error,
    options,
    defaultValue,
    disabledOptions,
    children,
    showErrorOutLine,
    isRequired = true,
  } = props;

  const [isPlaceHolderHidden, setIsPlaceholderHidden] = useState(false);

  return (
    <div
      className={classNames('SelectInput', className, { hasError: (!!error || showErrorOutLine), hasValue: isPlaceHolderHidden || !!defaultValue })}
    >
      {/* If you provide children (SelectInput as a block component) then it replaces the label */}
      <label htmlFor={id}>
        {children}
        {!children && <span className="SelectInput-label">{label}</span>}

        <select
          id={id}
          name={id}
          defaultValue={defaultValue || ''}
          onChange={(e) => {
            onChange(e.currentTarget.value || '');
            if (isRequired) {
              setIsPlaceholderHidden(true);
            }
          }}
        >
          {/* @TODO Look into A11Y here */}
          {/* hidden after first change? */}
          {placeholder && (
            <option value="" key="placeholder" disabled={isRequired} hidden={isPlaceHolderHidden}>
              {placeholder}
            </option>
          )}

          {options.map((option) => (
            <option
              value={option}
              key={option}
              disabled={disabledOptions && disabledOptions.indexOf(option) !== -1}
            >
              {option}
            </option>
          ))}
        </select>

        {/* Error message */}
        {error && (
          <div className="SelectInput-error">
            <Icon name="ic-exclamation" />
            <span>{error}</span>
          </div>
        )}
      </label>
    </div>
  );
};
